<app-loading *ngIf="isLoading"></app-loading>
<div class="m-4">
  <div class="row px-3">
    <div class="col-6 pl-0">
      <p class="titleFont">
        {{ "label.claim.claimDetails.otherInsuranceDetailsLabel" | translate }}
      </p>
    </div>
    <div class="col-6 text-right">
      <div class="circle circle-plus" [ngStyle]="{ 'pointer-events':  'none' }" (click)="addRow()">
        <img src="{{ addIcon }}" alt="Plus Icon" class="plus-icon" />
      </div>
    </div>
  </div>
  <div class="card mt-2 px-3 pt-4 pb-2" [ngStyle]="{ 'pointer-events':  'none' }">
    <dxc-table class="table-responsive-sm dashabordTable pb-4 pt-4">
      <tr class="header-filter">
        <th id="policyNo">
          <div class="labelSpace ml-2">
            {{ "label.claim.claimDetails.policyNumber" | translate }}
          </div>
        </th>
        <th id="issueDate">
          <div class="labelSpace">
            {{ "label.claim.claimDetails.dateOfIssue" | translate }}
          </div>
        </th>
        <th id="insurerName">
          <div class="labelSpace">
            {{ "label.claim.claimDetails.nameOfInsurer" | translate }}
          </div>
        </th>
        <th id="planType">
          <div class="labelSpace">
            {{ "label.claim.claimDetails.planType" | translate }}
          </div>
        </th>
        <th id="sumAssured">
          <div class="labelSpace">
            {{ "label.claim.claimDetails.sumAssured" | translate }}
          </div>
        </th>
        <th id="claimNotified">
          <div class="labelSpace">
            {{ "label.claim.claimDetails.claimNotified" | translate }}
          </div>
        </th>
        <th colspan="1"></th>
        <th colspan="1"></th>
      </tr>
      <tr
        class="table-header"
        *ngFor="let item of otherInsuranceClaimsList; index as i"
      >
        <td>
          <span class="mobile-label">
            {{ "label.claim.claimDetails.policyNumber" | translate }}
          </span>
          <span>
            <custom-input-text
              digitOnly
              margin="xxsmall"
              [model]="item.summary.policyNumber"
              [disabled]="true"
            ></custom-input-text>
          </span>
        </td>
        <td>
          <span class="mobile-label">
            {{ "label.claim.claimDetails.dateOfIssue" | translate }}
          </span>
          <span>
            <custom-date-picker
              margin="xxsmall"
              [placeholder]="true"
              [model]="item.summary.dateOfIssue"
              [disabled]="true"
            ></custom-date-picker>
          </span>
        </td>
        <td>
          <span class="mobile-label">
            {{ "label.claim.claimDetails.nameOfInsurer" | translate }}
          </span>
          <span>
            <custom-input-text
              margin="xxsmall"
              [model]="item.summary.nameOfInsurer"
              [disabled]="true"
            >
            </custom-input-text>
          </span>
        </td>
        <td>
          <span class="mobile-label">
            {{ "label.claim.claimDetails.planType" | translate }}
          </span>
          <span>
            <custom-input-text
              margin="xxsmall"
              [model]="item.summary.typeOfPlan"
              [disabled]="true"
            >
            </custom-input-text>
          </span>
        </td>
        <td>
          <span class="mobile-label">
            {{ "label.claim.claimDetails.sumAssured" | translate }}
          </span>
          <span>
            <custom-input-text
              margin="xxsmall"
              [model]="item.summary.sumAssured"
              [disabled]="true"
            >
            </custom-input-text>
          </span>
        </td>
        <td>
          <span class="mobile-label">
            {{ "label.claim.claimDetails.claimNotified" | translate }}
          </span>
          <span>
            <custom-toggle-group
              margin="xxsmall"
              [listToggle]="commonToggleList"
              [value]="item.summary.claimNotified"
            >
            </custom-toggle-group>
          </span>
        </td>
        <td>
          <custom-button
            [iconSrc]="editIcon"
            margin="xxsmall"
            mode="text"
            [disabled]="true"
          >
          </custom-button>
        </td>
        <td>
          <custom-button
            [iconSrc]="deleteIcon"
            margin="xxsmall"
            mode="text"
            (onClick)="deleteRow(i)"
            [disabled]="true"
          >
          </custom-button>
        </td>
      </tr>
    </dxc-table>
  </div>
  <div class="row endButtons">
    <custom-button
      class="saveBtn"
      label="{{ 'label.claim.claimDetails.save' | translate }}"
      mode="primary"
      margin="xsmall"
      (onClick)="onCloseDialog()"
    >
    </custom-button>
    <custom-button
      class="cancelBtn"
      label="{{ 'label.claim.claimDetails.cancel' | translate }}"
      mode="secondary"
      margin="xsmall"
      (onClick)="onCloseDialog()"
    >
    </custom-button>
  </div>
</div>
